import BookmarkContainer from "../../components/applications/bookmarks";

const Bookmarks = () => {
  return <BookmarkContainer />;
};

export default Bookmarks;
